import { Compass, Gamepad2, Guitar } from 'lucide-react';
import { hobbies } from '../data/portfolio';
import { FadeUp } from './Reveal';

const ICONS = [Compass, Gamepad2, Guitar];

export default function Hobbies() {
    return (
        <section id="hobbies" data-testid="hobbies-section" className="relative z-10 bg-ink py-24 md:py-32">
            <div className="mx-auto max-w-[1300px] px-6">
                <FadeUp>
                    <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-mint">
                        Beyond The Build
                    </p>
                    <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-snow md:text-5xl">
                        What fuels the curiosity off-clock
                    </h2>
                </FadeUp>

                <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-3">
                    {hobbies.map((h, i) => {
                        const Icon = ICONS[i % ICONS.length];
                        return (
                            <FadeUp key={h.title} delay={i * 0.08} className="h-full">
                                <article
                                    data-testid={`hobby-card-${i}`}
                                    className="flex h-full flex-col rounded-2xl border border-white/[0.08] bg-panel p-7 transition-all duration-300 hover:-translate-y-1 hover:border-mint/30"
                                >
                                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-mint/25 bg-mint/10 text-mint">
                                        <Icon size={18} strokeWidth={1.8} />
                                    </span>
                                    <h3 className="mt-5 font-display text-lg font-bold text-snow">
                                        {h.title}
                                    </h3>
                                    <p className="mt-2 text-sm text-mist">{h.value}</p>
                                    <p className="mt-auto pt-5 font-mono text-[10px] uppercase tracking-[0.18em] text-mist/40">
                                        {h.note}
                                    </p>
                                </article>
                            </FadeUp>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
